import { useState } from "react";
import { IClassOptions } from "constants/constants";
import { LoginClassType } from "types/common/common.types";
import { UseFormGetValues } from "react-hook-form";
import {
  IUseClassOptionsChange,
  ParentFormSchema,
  StudentFormSchema
} from "../use-profile-form.types";
import { getGradeByClassType } from "utils/utils";

const UseClassOptionsChange = (
  getValues:
    | UseFormGetValues<StudentFormSchema>
    | UseFormGetValues<ParentFormSchema>
    | UseFormGetValues<Omit<StudentFormSchema, "parentName" | "parentNumber">>
): IUseClassOptionsChange => {
  const [gradeOptions, setGradeOptions] = useState<IClassOptions[]>([]);

  const handleClassOptionsChange = () => {
    if (getValues().classType == LoginClassType["SD"]) {
      setGradeOptions(getGradeByClassType(LoginClassType["SD"]));
    } else if (getValues().classType == LoginClassType["SMP/MTs"]) {
      setGradeOptions(getGradeByClassType(LoginClassType["SMP/MTs"]));
    } else if (getValues().classType == LoginClassType["SMA/MA"]) {
      setGradeOptions(getGradeByClassType(LoginClassType["SMA/MA"]));
    } else if (getValues().classType == LoginClassType["SMK"]) {
      setGradeOptions(getGradeByClassType(LoginClassType["SMK"]));
    } else {
      setGradeOptions([]);
    }
  };
  return { gradeOptions, handleClassOptionsChange };
};

export default UseClassOptionsChange;
